import { isEmpty } from 'lodash';

const getPublishStatusesResponse = (response) => {
  if (isEmpty(response?.data?.briefDraftStatuses)) return [];

  const publishStatuses = response.data.briefDraftStatuses.map((publishStatus) => {
    return {
      value: publishStatus?.isPublished,
      label: publishStatus?.label,
    };
  });

  return publishStatuses;
};

export default getPublishStatusesResponse;
